"use client";

import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import { PRODUCT_PERMISSIONS } from "@/constants/modules.permissions";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import useHasNoPermission from "@/hooks/use-check-permissions";
import IProduct from "@/interfaces/product.interface";
import { ProductsMessages } from "@/messages/products/product.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ProductsMessages;
  selected: IProduct;
}

export function ProductPopover({ isOpen, anchorEl, onClose, messages, selected }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();

  const hasNoPermissionToEdit = useHasNoPermission(PRODUCT_PERMISSIONS.EDIT);

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<EditIcon />}
        disabled={hasNoPermissionToEdit}
        onClick={() => router(ROUTE_URLS.updateProduct(lang, selected.id))}
        title={messages.updatePopover}
      />
    </Menu>
  );
}
